import Vue from 'vue';
import Router from 'vue-router';
import Blank from '@/components/Administration/Blank';
import Customers from '@/components/Customer/Customers';
import CustomersCOD from '@/components/Customer/CustomersCOD';
import Dashboard from '@/components/Overview/Dashboard';
import Departments from '@/components/Company/Departments';
import Document from '@/components/Document/Document';
import Interactive from '@/components/PriceList/Interactive';
import PriceListImport from '@/components/PriceList/PriceListImport';
import PriceList from '@/components/PriceList/PriceList';
import Quote from '@/components/Quote/Quote';
import QuoteList from '@/components/Quote/QuoteList';
// import Reports from '@/components/Reports';
import Roles from '@/components/Company/Roles';
import SignIn from '@/components/User/SignIn';
import SignOut from '@/components/User/SignOut';
import Staff from '@/components/Company/Staff';
import StripCalculator from '@/components/PriceList/StripCalculator';
import stripcalc from '@/components/PriceList/stripcalc';
// ----------------------------------------
// Supplier pages.
import MSSL from '@/components/Supplier/MSSL';
import MSSL2 from '@/components/Supplier/MSSL2';
import MSSLData from '@/components/Supplier/MSSLData';

Vue.use(Router);

export default new Router({
    mode: 'history',
    routes: [
        { path: '/', name: 'SignIn', component: SignIn },
        { path: '/Blank', name: 'Blank', component: Blank },
        { path: '/CRP', name: 'CRP', component: PriceList },
        { path: '/Dashboard', name: 'Dashboard', component: Dashboard },
        { path: '/Customers', name: 'Customers', component: Customers },
        { path: '/CustomersCOD', name: 'CustomersCOD', component: CustomersCOD },
        { path: '/Departments', name: 'Departments', component: Departments },
        { path: '/Document', name: 'Document', component: Document },
        { path: '/Interactive', name: 'Interactive', component: Interactive },
        { path: '/PriceListImport', name: 'PriceListImport', component: PriceListImport },
        { path: '/PriceList', name: 'PriceList', component: PriceList },
        // { path: '/Reports', name: 'Reports', component: Reports },
        { path: '/Roles', name: 'Roles', component: Roles },
        { path: '/Quote', name: 'Quote', component: Quote },
        { path: '/QuoteList', name: 'QuoteList', component: QuoteList },
        { path: '/QuoteSession', name: 'QuoteSession', component: Quote },
        { path: '/SignOut', name: 'SignOut', component: SignOut },
        { path: '/Staff', name: 'Staff', component: Staff },
        { path: '/StripCalculator', name: 'StripCalculator', component: StripCalculator },
        { path: '/stripcalc', name: 'stripcalc', component: stripcalc },
        // ----------------------------------------
        // Supplier pages.
        { path: '/MSSL', name: 'MSSL', component: MSSL },
        { path: '/MSSL2', name: 'MSSL2', component: MSSL2 },
        { path: '/MSSLData', name: 'MSSLData', component: MSSLData },
    ],
});



// WEBPACK FOOTER //
// ./src/router/index.js